import type { NetworkKey } from './config';

export type MarketPriorityEntry = {
  address: string;
  listed?: boolean;
  promoted?: number;
};

// Configure market priority here.
// - listed: always float this market to the top inside its lifecycle tab.
// - promoted: higher number ranks above lower numbers (when listed flag is equal).
//
// Example:
// { address: '0x1234...abcd', listed: true, promoted: 100 }
export const MARKET_PRIORITY_CONFIG: Record<NetworkKey, MarketPriorityEntry[]> = {
  mainnet: [
    // Add mainnet priority markets here.
  ],
  testnet: [
    // Add testnet priority markets here.
  ],
};

export type MarketPriorityInfo = {
  listed: boolean;
  promoted: number;
};

export function getMarketPriorityMap(network: NetworkKey): Map<string, MarketPriorityInfo> {
  const map = new Map<string, MarketPriorityInfo>();
  for (const entry of MARKET_PRIORITY_CONFIG[network]) {
    const key = entry.address.toLowerCase();
    if (!key) continue;
    map.set(key, {
      listed: Boolean(entry.listed),
      promoted: Number(entry.promoted || 0),
    });
  }
  return map;
}

export function getMarketPrioritySortKey(info: MarketPriorityInfo): number {
  const listedWeight = info.listed ? 1_000_000 : 0;
  return listedWeight + info.promoted;
}
